var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"code"},[(_vm.$i18n.locale!='en')?_c('span',[_vm._v("SKU Reference：")]):_vm._e(),_vm._v(" "),(_vm.$i18n.locale=='en')?_c('span',[_vm._v("Product Code：")]):_vm._e(),_vm._v("\n  "+_vm._s(_vm.codeValue)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2dcd2fe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/card/GoodCode.vue
// module id = null
// module chunks = 